import React from "react";
import cx from "classnames";
import { DOMPurifyWithTargetBlankHook } from "component-library";
import "./BreakdownInfoTableRow.scss";
import { dataTestIds } from "data-testids";

export interface IBreakdownInfoTableRowProps {
  title: string;
  content?: string | React.JSX.Element;
  keepFormatting?: boolean;
  isPrintView?: boolean;
}

const BreakdownInfoTableRow: React.FC<
  React.PropsWithChildren<IBreakdownInfoTableRowProps>
> = (props) => {
  const isChildrenString = typeof props.content === "string";

  return (
    <div
      className={cx("c-breakdown-info-table-row g-inner-grid", {
        "c-breakdown-info-table-row--keep-formatting": props.keepFormatting,
        "c-breakdown-info-table-row--print": props.isPrintView,
      })}
      data-testid={`${dataTestIds.nuJobsApp["BreakdownDetails.Table.row"]}-${props.title}`}
    >
      <div className="c-breakdown-info-table-row__column">{props.title}</div>
      {isChildrenString ? (
        <div
          className="c-breakdown-info-table-row__column rich-text"
          dangerouslySetInnerHTML={{
            __html: DOMPurifyWithTargetBlankHook.sanitize(
              props.content as string
            ),
          }}
        />
      ) : (
        <div className="c-breakdown-info-table-row__column">
          {props.content}
        </div>
      )}
    </div>
  );
};

export default BreakdownInfoTableRow;
